import { useTranslation } from "react-i18next";
import React from "react";

function CodeShareIcon() {
  const { t } = useTranslation();
  return (
    <span className="codeshare-icon" title={t("OAG_CODESHARE_WARNING")}>
      &#8727;
    </span>
  );
}

export default CodeShareIcon;
